import { connect } from 'react-redux'

import { AppState } from '../reducers'
import Product from '../components/Product'
import * as selectors from '../selectors'
import * as actions from '../actions'

const mapStateToProps = (state: AppState) => ({
	price: selectors.getPrice(state),
	product: selectors.getProduct(state),
	locations: selectors.getLocation(state),
	locale: selectors.getLocale(state),
	stocks: selectors.getStocks(state),
	bestBefore: state.data.bestBefore,
})

const mapDispatchToProps = {
	fetchProduct: actions.fetchProduct as any,
	searchBarcode: actions.searchBarcode as any,
}

const ConnectedProduct = connect(mapStateToProps, mapDispatchToProps)(Product)

export type ProductProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps

export default ConnectedProduct
